module.exports = __webpack_public_path__ + "img/p1-p1-biaoti1.5c4bc93c.png";